export default function popup() {
    const elements = document.querySelectorAll('.js-popup');

    if (!elements) return;

    elements.forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault;

            const {url} = element.dataset;
            const popup = window.open(url, 'popup', 'width=600,height=600');
            popup.focus();
        });
    });
};
